import http from 'services/http-service';
import AppConsts from '../../libs/appconst';

const ShortenLinkService = {
    GetList(searchKey: string, skipCount: number, maxResultCount: number) {
        let response = http.get(AppConsts.API_SHORTENURL_URL + '/shorten', { baseURL: AppConsts.API_SHORTENURL_URL, params: { searchKey: searchKey, skipCount: skipCount, maxResultCount: maxResultCount } });
        return response;
    },

    Get(id: any) {
        let response = http.get(AppConsts.API_SHORTENURL_URL + `/shorten/${id}`);
        return response;
    },

    Create(name: string, longUrl: string, backHalf: string, isHaveUtm: boolean, utmSource: string, utmMedium: string, utmCampaign: string, isHaveVoucher: boolean, voucherCode: string) {
        var url = new URL(longUrl);

        if (url.searchParams.has("utm_source"))
            url.searchParams.delete("utm_source")
        if (url.searchParams.has("utm_medium"))
            url.searchParams.delete("utm_medium")
        if (url.searchParams.has("utm_campaign"))
            url.searchParams.delete("utm_campaign")

        if (isHaveUtm) {
            url.searchParams.set("utm_source", utmSource);
            url.searchParams.set("utm_medium", utmMedium);
            url.searchParams.set("utm_campaign", utmCampaign);
        }

        if (url.searchParams.has("voucher"))
            url.searchParams.delete("voucher")

        if (isHaveVoucher) {
            url.searchParams.set("voucher", voucherCode);
        }

        var urlFinal = url.origin + url.pathname + url.search;

        let response = http.post(AppConsts.API_SHORTENURL_URL + '/shorten', {
            name: name,
            title: name,
            longUrl: urlFinal,
            backHalf: backHalf
        });
        return response;
    },

    Update(id: any, name: string, longUrl: string, backHalf: string, isHaveUtm: boolean, utmSource: string, utmMedium: string, utmCampaign: string, isHaveVoucher: boolean, voucherCode: string, status: number) {
        var url = new URL(longUrl);
        if (url.searchParams.has("utm_source"))
            url.searchParams.delete("utm_source")
        if (url.searchParams.has("utm_medium"))
            url.searchParams.delete("utm_medium")
        if (url.searchParams.has("utm_campaign"))
            url.searchParams.delete("utm_campaign")

        if (isHaveUtm) {
            url.searchParams.set("utm_source", utmSource);
            url.searchParams.set("utm_medium", utmMedium);
            url.searchParams.set("utm_campaign", utmCampaign);
        }

        if (url.searchParams.has("voucher"))
            url.searchParams.delete("voucher")

        if (isHaveVoucher) {
            url.searchParams.set("voucher", voucherCode);
        }

        var urlFinal = url.origin + url.pathname + url.search;

        let response = http.put(AppConsts.API_SHORTENURL_URL + '/shorten', {
            id: id,
            name: name,
            title: name,
            longUrl: urlFinal,
            backHalf: backHalf,
            status: status
        });
        return response;
    }
};

export default ShortenLinkService;